import React from "react";
import PropTypes from "prop-types";

import styles from "./AsideSearch.module.css";
import SearchBar from "../SearchBar/SearchBar";
import CardHeader from "../../components/ContentElements/CardHeader/CardHeader";

const AsideSearch = (props) => {
  if (!props.data) {
    return null;
  }

  const {
    data: { sidebarTitle: { text, isCaps } = {}, placeholder },
  } = props;
  const showCardHeader = props.data.sidebarTitle !== undefined;

  return (
    <div className={styles.asideSearch} role="search">
      {showCardHeader && (
        <CardHeader
          text={text}
          isCaps={isCaps}
          styles={styles}
          id="searchHeader"
        />
      )}
      <SearchBar
        placeholder={placeholder && placeholder["placeholder-text"]}
        displayDropdown={false}
      />
    </div>
  );
};

export default AsideSearch;

AsideSearch.propTypes = {
  data: PropTypes.shape({
    header: PropTypes.object,
    placeholder: PropTypes.object,
    isCaps: PropTypes.object,
    sidebarTitle: PropTypes.object,
  }),
};
